<template>
    <div :class="[small === true ? 'mediapool-small':'', mode, elementClass, 'mediapool-element']">
        <div class="mediapool-file-list">
            <div v-bind:class="[selected ? 'selected' : '', 'media-file row no-selection']" :data-file-id="media.id">
                <div class="element-data"
                     :data-file-id="media.id"
                     :data-type="media.media_type"
                     :data-width="media.informations.width"
                     :data-height="media.informations.height"
                     :data-page-count="media.informations.count"
                     :data-duration="media.informations.duration"
                     :data-valid-from="media.parameters['valid-from']"
                     :data-valid-to="media.parameters['valid-to']"
                     :data-file-name="media.file_name + '.' + media.file_extension"
                     :data-preview-name="media.original_image"
                     :data-display-name="media.display_name"></div>

                <div class="col-md-2">
                    <div class="pull-left">
                        <div class="selection" v-if="deletePrivilege === '1'"
                             @click="selectMedia()">
                        </div>
                    </div>
                    <div @click="showMedia()" class="image-container pull-right m-r-xl"
                         :style="{
                             backgroundImage: 'url(\''+media.thumbnail+'\')',
                             backgroundSize: media.thumbnail.endsWith('.svg') ? 'contain' : 'cover'
                         }">
                        <div class="inactive" v-if="media.inactive"></div>
                        <div class="video-overlay" v-if="media.media_type === 'video'">
                            <div class="wrap text-center">
                                <i class="fa-regular fa-play text-white fa-2x"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 name wrap-text file-name">
                    {{ media.display_name }}
                    <template v-if="media.display_name !== media.file_name">
                        <br>{{ '[' + media.file_name + '.' + media.file_extension + ']' }}
                    </template>
                </div>
                <div class="col-md-1">
                    <div v-for="tag in media.tags" class="label label-primary m-r-xs m-b-xs pull-left">
                        {{ tag.name }}
                    </div>
                </div>
                <div :class="[media.parameters['validity-status'], 'col-md-2 text-center']">
                    {{ media.parameters['validity-text'] }}
                </div>
                <div class="col-md-1 attr text-right">
                    {{ media.media_size_string }}
                </div>
                <div class="col-md-1 attr">
                    {{media.created_at}}
                </div>
                <div class="col-md-1 attr">
                    {{media.updated_at}}
                </div>
                <div class="col-md-1 text-right actions">
                    <button v-if="editPrivilege === '1'"
                            @click="editMedia()"
                            type="button"
                            class="btn btn-primary">
                        <i class="fa-regular fa-pencil" aria-hidden="true" :title="t_edit"></i>
                    </button>
                    <button v-if="deletePrivilege === '1'"
                            @click="deleteMedia()"
                            type="button"
                            class="btn btn-primary">
                        <i class="fa-regular fa-trash" :title="t_delete"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'media',
            'small',
            'mode',
            'viewPrivilege',
            'editPrivilege',
            'deletePrivilege',
            'dragDrop',
            'elementClass'
        ],
        data: function () {
            return {
                t_added: Lang.langGet("Added"),
                t_modified: Lang.langGet("Modified"),
                t_edit: Lang.langGet("Edit"),
                t_delete: Lang.langGet("Delete"),
                t_validity: Lang.langGet("Validity"),
                t_file_name: Lang.langGet("Filename"),
                activeProject: Laravel.activeProject,
                selected: false
            }
        },
        methods: {
            editMedia: function () {
                EaseEventBus.fire('editMedia', this.media);
            },
            deleteMedia: function () {
                EaseEventBus.fire('deleteMedia', this.media);
            },
            showMedia: function () {
                if (this.media.file_name === 'dummy_placeholder') {
                    EaseEventBus.fire('newContent', this.media.media_type);
                } else {
                    EaseEventBus.fire('showMedia', this.media);
                }
            },
            newMedia: function () {
            },
            selectMedia: function () {
                this.selected = !this.selected;
                EaseEventBus.fire('selectMedia');
            },
            balloonData: function (media) {
                let data = this.t_validity + ': ' +  media.parameters['validity-text'] + '\n' + this.t_added + ': ' + media.created_at + '\n' + this.t_modified + ': ' + media.updated_at;
                if (media.file_name !== media.display_name) {
                    data = this.t_file_name + ': ' + media.file_name + '.' + media.file_extension + '\n' + data;
                }
                return data;
            }
        },
        mounted() {
            EaseEventBus.listen('updateMedialist', () => {
              this.selected = false;
            });
        }
    }
</script>
